import { RegistrationStep } from '@/types/registration.types';
import { Put } from '../helpers';

export function UpdateRegistrationSteps(
  event_uuid: string,
  updatedSteps: RegistrationStep[]
): Promise<RegistrationStep[]> {
  const updated_steps = updatedSteps.map((step) => {
    if (!step?.questions?.length) {
      return step;
    } else {
      return {
        ...step,
        questions: step.questions.map((q) => q.registration_question),
      };
    }
  });

  return Put({ url: '/v3/admin/events/registration-steps', body: { event_uuid, updated_steps } });
}
